<div
  class="flex flex-col gap-2 rounded-[8px] p-4 box-border w-full bg-neutrals-0 border-neutrals-500"
>
  <div class="flex justify-between items-center">
    <ui-paragraph
      type="p12"
      mobile-type="p12"
      font-weight="semibold"
      text-color="neutrals-700"
    >
      {{ title }}
    </ui-paragraph>
    <unicon-menu-tooltip>
      <div menuTooltipContent>
        <ng-content select="[menuTooltipInternalrContent]"></ng-content>
      </div>
    </unicon-menu-tooltip>
  </div>
  <div class="flex flex-col">
    <div class="w-full h-[110px] flex justify-center">
      <canvas
        style="height: 100% !important; width: 100% !important"
        baseChart
        [data]="doughnutChartData"
        [options]="doughnutChartOptions"
        type="doughnut"
      ></canvas>
    </div>
    <div class="flex justify-between items-end px-2 mt-[-64px] pb-[13px]">
      <ui-paragraph type="p8" mobile-type="p8" text-color="neutrals-500">
        40min
      </ui-paragraph>
      <div class="h-[68px] w-[68px] relative">
        <svg
          class="absolute top-[44px] left-[30px]"
          xmlns="http://www.w3.org/2000/svg"
          width="34"
          height="8"
          viewBox="0 0 34 8"
          fill="none"
        >
          <circle cx="4" cy="4" r="4" fill="#D9D9D9" />
          <rect
            width="3.20696"
            height="29.4409"
            rx="1.60348"
            transform="matrix(0.0499997 -0.998749 0.999999 -0.000964915 4.00781 5.8125)"
            fill="#D9D9D9"
          />
        </svg>
      </div>
      <ui-paragraph type="p8" mobile-type="p8" text-color="neutrals-500">
        0min
      </ui-paragraph>
    </div>
    <div class="flex flex-col justify-center items-center box-border">
      <div class="flex flex-row justify-center items-end">
        <ui-headline
          type="h48"
          mobile-type="h48"
          font-weight="semibold"
          text-color="neutrals-900"
        >
          {{ value }}
        </ui-headline>
        <div class="pb-1">
          <ui-headline
            type="h28"
            mobile-type="h28"
            font-weight="semibold"
            text-color="neutrals-900"
          >
            {{ measurementUnit }}
          </ui-headline>
        </div>
      </div>
      <unicon-percent-indicator
        class="flex-none"
        [positive]="true"
        [percent]="12"
      />
    </div>
  </div>
</div>
